<template>
  <div v-if="!loading" class="sp-mode">
    <header id="header">
      <b-navbar toggleable="lg">
        <b-navbar-brand class="brand">
          <a href="https://www.westjr.co.jp/"><img id="logo" src="../../assets/images/jr_logo.svg"  width="41" alt="JR西日本旅客鉄道株式会社"></a>
          <router-link id="delay" :to="{ name: 'SpSiteTop' }">遅延証明書</router-link>
        </b-navbar-brand>
      </b-navbar>
    </header>
    <article>
      <div id="termsOfService" v-if="termsOfService" v-html="termsOfService" @click="onTermsLinkClick"></div>
    </article>
    <sp-site-footer/>
  </div>
</template>

<script>
import SpSiteHeader from '@/components/sp/SpSiteHeader'
import SpSiteFooter from '@/components/sp/SpSiteFooter'
import { mapState } from 'vuex'
export default {
  name: 'SpOutline',
  components: {
    SpSiteHeader,
    SpSiteFooter
  },
  created () {
    this.$store.dispatch('timeZone/all')
    this.$store.dispatch('externalData/termsService')
    this.$store.commit('loading/setStatus', false)
  },
  methods: {
    onTermsLinkClick (e) {
      const anchor = e.target.closest('a[href*="delay.trafficinfo.westjr.co.jp"]')
      if (!anchor) return
      e.preventDefault()
      this.$router.push({ name: 'SpSiteTop' })
    }
  },
  computed: {
    ...mapState('areaLine', {
      areas: state => state.areas
    }),
    ...mapState('externalData', {
      termsOfService: state => state.termsOfService
    }),
    ...mapState('timeZone', {
      timeZones: state => state.timeZones
    }),
    ...mapState('loading', {
      loading: state => state.status
    })
  }
}
</script>
<style lang="scss" scoped>
@import '../../css/variables';
h1 {
  font-size: 1.28rem !important;
}
h2 {
  font-size: 1.12rem !important;
}
header {
  border-bottom: 1px solid #e6e6e6;
}
a {
  &#delay {
    margin-left: 16px;
    font-weight: 600;
  }
}
.brand {
  margin-left: 16px;
  strong {
    color: $primary;
    margin-left: 1rem;
    font-size: 1.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/SpOutline.vue